let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b4NwV")).then(() => parcelRequire('8cB3R'));